(function (Drupal, $, drupalSettings, once) {
  'use strict';

  Drupal.behaviors.accident_report = {
    attach: function (context, settings) {
      $.expr[':'].regex = function (elem, index, match) {
        var matchParams = match[3].split(',');
        var validLabels = /^(data|css):/;
        var attr = {
          method: matchParams[0].match(validLabels) ? matchParams[0].split(':')[0] : 'attr',
          property: matchParams.shift().replace(validLabels, '')
        };
        var regexFlags = 'ig';
        var regex = new RegExp(matchParams.join('').replace(/^\s+|\s+$/g, ''), regexFlags);
        return regex.test(jQuery(elem)[attr.method](attr.property));
      };

      const nextButton = $('.js-form-next', context);
      const prevButton = $('.js-form-prev', context);
      const submitButton = $('.ipaf-accident-report-add-form .js-form-submit:not(#edit-field-people-involved-actions-ief-add),.ipaf-accident-report-form .js-form-submit:not(#edit-field-people-involved-actions-ief-add)', context);
      // Set button visibility on page load
      buttonVisibility();
      // Set button visibility if user manually cycles tabs
      $('.horizontal-tab-button', context).click(function () {
        buttonVisibility();
      });
      $('.js-form-next', context).click(function (e) {
        if (ValidatePane()) {
          $('.horizontal-tab-button.selected', context).next().find('a').click();
          buttonVisibility();
          scrollToForm();
        }
        e.stopImmediatePropagation();
      });
      $('.js-form-prev', context).click(function (e) {
        $('.horizontal-tab-button.selected', context).prev().find('a').click();
        buttonVisibility();
        scrollToForm();
        e.stopImmediatePropagation();
      });

      // $(submitButton).click(function(e) {
        // if (ValidatePane()) {
        //   $("#ipaf-accident-report-add-form").submit();
        // }
        // e.preventDefault();
      // });
      $('#ipaf-accident-report-add-form,#ipaf-accident-report-form').submit(function () {
        return ValidatePane();
      });

      $(document).on('click', '.ipaf-accident-report-category', function (e) {
        $(this, context).toggleClass('active');
        $(this, context).next().toggleClass('active');
        e.stopImmediatePropagation();
      });

      function ValidatePane () {
        var errors = [];
        $('.message--accident-form-validate').remove();
        $('.horizontal-tabs-pane:not(.horizontal-tab-hidden) select.required').each(function () {
          if ($(this).val() == '_none') {
            var errorElement = $(this).parent().parent();
            var errorText = $(errorElement).find('label').text() + ' ' + drupalSettings.requiredField;
            if ($.inArray(errorText, errors) === -1) {
              errors.push(errorText);
            }
          }
        });

        $('.horizontal-tabs-pane:not(.horizontal-tab-hidden) input[type=date]').each(function () {
          if (!$(this).val()) {
            var errorElement = $(this).parent().parent().parent();
            var errorText = $(errorElement).find('.label').text() + ' ' + drupalSettings.requiredField;
            if ($.inArray(errorText, errors) === -1) {
              errors.push(errorText);
            }
          }
        });

        if ($('.horizontal-tabs-pane:not(.horizontal-tab-hidden) .ief-form .form-radios-list').is(':visible')) {
          errors.push(drupalSettings.addPersonError);
        }

        if ($('.horizontal-tabs-pane:not(.horizontal-tab-hidden) .ajax-progress').is(':visible')) {
          errors.push(drupalSettings.addPersonWait);
        }

        $('.horizontal-tabs-pane:not(.horizontal-tab-hidden) input:not([id*=inline-entity-form])').each(function () {
          if ($(this).attr('type') == 'radio') {
            if (!$('input:radio[name=' + $(this).attr('name') + ']:checked').val()) {
              var errorElement = $(this).parent().parent().parent().parent();
              if ($(this).attr('name') == 'field_incident_classification') {
                errorElement = $(this).parent().parent().parent().parent().parent();
              }
              if ($(errorElement).attr('required') == 'required') {
                var errorText = $(errorElement).find('.fieldset-legend').text() + ' ' + drupalSettings.requiredField;
                if ($.inArray(errorText, errors) === -1) {
                  errors.push(errorText);
                }
              }
            }
          }
        });

        if (errors.length) {
          $('#ipaf-accident-report-add-form,#ipaf-accident-report-form').prepend('<div class="message message--error message--accident-form-validate"><ul class="message__list"></ul></div>');
          $.each(errors, function (index, item) {
            $('.message--accident-form-validate .message__list').append('<li class="message__item">' + item + '</li>');
          });
          $('body,html').animate(
            {scrollTop: $('.message--accident-form-validate').offset().top - 20},
            200
          );
          return false;
        }
        return true;
      }

      // Determine where we are in the form process and hide/show buttons. Save only shows on last step.
      function buttonVisibility () {
        if (!$('.horizontal-tab-button.selected', context).prev().length) {
          prevButton.hide();
        } else {
          prevButton.show();
        }
        if (!$('.horizontal-tab-button.selected', context).next().length) {
          nextButton.hide();
          submitButton.show();
        } else {
          nextButton.show();
          submitButton.hide();
        }
      }

      // Scroll to top of form on next or prev click to indicate there is more content
      function scrollToForm () {
        $([document.documentElement, document.body], context).animate({
          scrollTop: $('#ipaf-accident-report-add-form,#ipaf-accident-report-form', context).offset().top
        }, 500);
      }

      $(once('build', '.ipaf-accident-report-add-form,.ipaf-accident-report-form', context)).each(function () {
        // Custom select wrapper
        $('select', context).wrap('<div class="select-wrapper"></div>');
        $('#edit-field-incident-classification', context).append('<div class="ipaf-accident-report-category"><p>' + drupalSettings.classificationCategoryFalls + '</p></div><div class="ipaf-accident-report-category__items incident-classification-category-falls"></div>');
        $('#edit-field-incident-classification', context).append('<div class="ipaf-accident-report-category"><p>' + drupalSettings.classificationCategoryContact + '</p></div><div class="ipaf-accident-report-category__items incident-classification-category-contact"></div>');
        $('#edit-field-incident-classification', context).append('<div class="ipaf-accident-report-category"><p>' + drupalSettings.classificationCategoryElectrical + '</p></div><div class="ipaf-accident-report-category__items incident-classification-category-electrical"></div>');
        $('#edit-field-incident-classification', context).append('<div class="ipaf-accident-report-category"><p>' + drupalSettings.classificationCategoryStability + '</p></div><div class="ipaf-accident-report-category__items incident-classification-category-stability"></div>');
        $('#edit-field-incident-classification', context).append('<div class="ipaf-accident-report-category"><p>' + drupalSettings.classificationCategoryPersonal + '</p></div><div class="ipaf-accident-report-category__items incident-classification-category-personal"></div>');
        $('#edit-field-incident-classification', context).append('<div class="ipaf-accident-report-category ipaf-accident-report-category--last"><p>' + drupalSettings.classificationCategoryMachine + '</p></div><div class="ipaf-accident-report-category__items incident-classification-category-machine"></div>');
      });

      $('.js-form-item-field-incident-classification', context).each(function () {
        var categoryfullid = $(this).find('input').attr('id');
        var categorywords = categoryfullid.split('-');
        var categoryid = categorywords[4];

        if (categoryid.includes('falls')) {
          $('.incident-classification-category-falls', context).append($(this));
        }
        if (categoryid.includes('contact')) {
          $('.incident-classification-category-contact', context).append($(this));
        }
        if (categoryid.includes('electrical')) {
          $('.incident-classification-category-electrical', context).append($(this));
        }
        if (categoryid.includes('stability')) {
          $('.incident-classification-category-stability', context).append($(this));
        }
        if (categoryid.includes('personal')) {
          $('.incident-classification-category-personal', context).append($(this));
        }
        if (categoryid.includes('machine')) {
          $('.incident-classification-category-machine', context).append($(this));
        }
      });

      $('input:regex(id, edit-field-people-involved-form-inline-entity-form.*?field-primary-injury-none.*?)').parent().hide();
      $('input:regex(id, edit-field-people-involved-form-inline-entity-form.*?field-body-part-injured-none.*?)').parent().hide();
      var outcomeConditional = ['Major injury', 'Minor injury', 'First aid'];
      if (!context.doctype) {
        if ($(context).attr('id') && $(context).attr('id').substr(0, 18) == 'inline-entity-form') {
          let iefType = $(context).find('>:first-child').attr('id').split('--')[0];
          if (iefType == 'edit-field-people-involved') {
            $('.ief-entity-submit').val(drupalSettings.savePersonText);
            if ($.inArray($('div:regex(class, js-form-item-field-people-involved-form-inline-entity-form.*?field-outcome) input:checked', context).val(), outcomeConditional) != -1) {
              $('.field--name-field-primary-injury').show();
              $('.field--name-field-body-part-injured').show();
            } else {
              $('.field--name-field-primary-injury').hide();
              $('.field--name-field-body-part-injured').hide();
              $('input:regex(id, edit-field-people-involved-form-inline-entity-form.*?field-primary-injury-none.*?)').prop('checked', true);
              $('input:regex(id, edit-field-people-involved-form-inline-entity-form.*?field-body-part-injured-none.*?)').prop('checked', true);
              $('input:regex(id, edit-field-people-involved-form-inline-entity-form.*?field-primary-injury-none.*?)').parent().hide();
              $('input:regex(id, edit-field-people-involved-form-inline-entity-form.*?field-body-part-injured-none.*?)').parent().hide();
            }
          }
        }
      }

      $('div:regex(class, js-form-item-field-people-involved-form-inline-entity-form.*?field-outcome)').click(function () {
        if ($.inArray($(this).find('.form-radio').val(), outcomeConditional) != -1) {
          $('.field--name-field-primary-injury').show();
          $('.field--name-field-body-part-injured').show();
        } else {
          $('.field--name-field-primary-injury').hide();
          $('.field--name-field-body-part-injured').hide();
          $('input:regex(id, edit-field-people-involved-form-inline-entity-form.*?field-primary-injury-none.*?)').prop('checked', true);
          $('input:regex(id, edit-field-people-involved-form-inline-entity-form.*?field-body-part-injured-none.*?)').prop('checked', true);
          $('input:regex(id, edit-field-people-involved-form-inline-entity-form.*?field-primary-injury-none.*?)').parent().hide();
          $('input:regex(id, edit-field-people-involved-form-inline-entity-form.*?field-body-part-injured-none.*?)').parent().hide();
        }
      });

      $('input[id^="edit-field-people-involved-actions-ief-add"]').val(drupalSettings.addPersonText);
      $('fieldset[id="edit-field-people-involved"] .fieldset-legend').text(drupalSettings.peopleInvlovedText);

      $('.horizontal-tab-button strong').each(function () {
        switch ($(this).text()) {
          case 'ABOUT':
            $(this).text(drupalSettings.tabAbout);
            break;
          case 'WHO':
            $(this).text(drupalSettings.tabWho);
            break;
          case 'MACHINE':
            $(this).text(drupalSettings.tabMachine);
            break;
          case 'ACTIVITY':
            $(this).text(drupalSettings.tabActivity);
            break;
          case 'WHAT HAPPENED':
            $(this).text(drupalSettings.tabWhatHappened);
            break;
        }
      });
    }
  };
})(window.Drupal, window.jQuery, drupalSettings, once);
